import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const HistorialSalidasApi = () => {
    const [cargando, setCargando] = useState(false);

    const getSalidasBodega = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("prod_bodega_salidas", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // responde con error si la salida ya no se puede revertir
    const validarReversionSalida = async (id) => {
        try {
            setCargando(true);
            const response = await api.get(
                `prod_bodega_salidas/${id}/validar_reversion`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const revertirSalida = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`prod_bodega_salidas/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getSalidasBodega,
        validarReversionSalida,
        revertirSalida,

        cargando,
    };
};
